import App from './Recarga.svelte';

const app = new App({ target: document.body });

export default app;
